module.exports = __webpack_public_path__ + "static/render_night_2K_sig-b437bdbd2f412e98f366f4394014f8b9.webp";